export default __webpack_public_path__ + "static/media/bgFortnite.2cee709d.jpg";